<template>
	<form-field-wrap
			:field-props="fieldProps"
			:is-error="isError"
			:field-value="fieldValue"
			:is-switch="isSwitch"
			:input-focus="inputFocus"
			:with-label="true"
      class="form__message"
	>
		<template>
			<textarea class="custom-scroll"
			          :class="[inputClass, 'form-field__input_'+fieldProps.CODE]"
			          v-validate="rules"
			          :placeholder="fieldProps.PLACEHOLDER"
			          :data-vv-as="fieldProps.TITLE"
			          :name="fieldProps.CODE"
			          :value="fieldValue"
			          :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
                @input="changeValue"
			          >
			</textarea>
		</template>
	</form-field-wrap>
</template>
<script>
	export default {
		name: "FormFieldTextarea",
	}
</script>
